import { Magic as MagicSDK } from 'magic-sdk';
import { OAuthExtension, OAuthProvider } from '@magic-ext/oauth';
import { InstanceWithExtensions, SDKBase } from '@magic-sdk/provider';

let magicInstance: InstanceWithExtensions<SDKBase, OAuthExtension[]> = null;

const magic = (key: string): InstanceWithExtensions<SDKBase, OAuthExtension[]> => {
    magicInstance =
        magicInstance ||
        new MagicSDK(key, {
            extensions: [new OAuthExtension()],
        });

    return magicInstance;
};

export const isLoggedIn = async (key: string) => {
    try {
        const isLoggedIn = await magic(key).user.isLoggedIn();
        return isLoggedIn;
    } catch (e) {
        throw e;
    }
};

interface LoginParams {
    email: string;
    key: string;
    redirectURI?: string;
}

export const login = ({ email, key, redirectURI }: LoginParams) => {
    return magic(key).auth.loginWithMagicLink({
        email,
        redirectURI,
        showUI: false,
    });
};

export const logout = async (key: string) => {
    try {
        await magic(key).user.logout();
    } catch (e) {
        throw e;
    }
};

export const loginWithToken = async (token: string, key: string) => {
    try {
        const didToken = await magic(key).auth.loginWithCredential(token);
        return didToken;
    } catch (e) {
        throw e;
    }
};

export const loginWithCredential = async (key: string) => {
    try {
        return await magic(key).auth.loginWithCredential();
    } catch (e) {
        throw e;
    }
};

export const getOauthRedirectResult = async (key: string) => {
    try {
        return await magic(key).oauth.getRedirectResult();
    } catch (e) {
        throw e;
    }
};

export const loginWithSocial = async (
    key: string,
    provider: OAuthProvider,
    redirectURI: string
) => {
    try {
        return await magic(key).oauth.loginWithRedirect({
            provider,
            redirectURI,
            scope: ['openid', 'https://www.googleapis.com/auth/userinfo.email'],
        });
    } catch (e) {
        throw e;
    }
};

export const getDIDToken = async (key: string) => {
    try {
        const token = await magic(key).user.getIdToken();
        return token;
    } catch (e) {
        throw e;
    }
};

export const getUserMetadata = async (key: string) => {
    try {
        const metadata = await magic(key).user.getMetadata();
        return metadata;
    } catch (e) {
        throw e;
    }
};

export const Magic = {
    isLoggedIn,
    login,
    logout,
    loginWithToken,
    loginWithCredential,
    getDIDToken,
    getUserMetadata,
};
